var render = function render(){var _vm=this,_c=_vm._self._c;return _c('activix-tooltip',{attrs:{"content":_vm.tooltip}},[_c('icon',{staticClass:"ml-4 link-grey | lg:ml-3",class:{
            'cursor-not-allowed text-grey-400': _vm.disabled,
            'spin-inverse': _vm.spinning,
            'text-grey-400 hover:text-grey-500': !_vm.active,
        },attrs:{"name":_vm.icon},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }